import { routeTicketEnum, type RoutesList } from '@core/router/routeNames';

export const allowedAnalyticsRoutes: RoutesList[] = [routeTicketEnum.ANALYTICS];
